<template>
  <a-modal
    :width="800"
    :closable="false"
    :dialog-style="{ top: '50px',height: '80vh',overflow: 'auto' }"
    :body-style="{maxHeight: 'calc(70vh - 18px)', overflow: 'auto' }"
    :maskClosable="false"
    :keyboard="false"
    :visible="visible"
    @cancel="start"
  >
    <!-- <h2 slot="title" style="text-align:center">{{ template.templateName }}</h2> -->
    <div slot="footer">
      <a-checkbox @change="change">
        我已阅读并同意该协议
      </a-checkbox>

      <a-divider type="vertical"></a-divider>

      <a-button @click="start" type="primary">继续支付</a-button>
    </div>
    <a-spin :spinning="loading">
      <div v-html="template.templateContent">
      </div>
    </a-spin>
  </a-modal>
</template>
<script>
import { getAction, postAction } from "@/api/manage";
export default {
  name: "UserAgreementModal",
  data() {
    return {
      visible: false,
      loading: false,
      isAgree: false,
      template: {}
    };
  },
  methods: {
    show() {
      this.visible = true;
      this.loading = true
      getAction('/message/sysMessageTemplate/getByCode', {code:'user-agreement'}).then(res=>{
        if(res.success){
          this.template = res.result
        }
      }).finally(()=>{
        this.loading = false
      })
    },
    change(e){
        console.log(e);
        this.isAgree = e.target.checked
    },
    start() {
      if (this.isAgree) {
        this.visible = false;
      } else {
        this.$message.info("请阅读并勾选协议");
      }
    },
  },
};
</script>
<style scoped>
.qrcode {
  width: 100%;
}
</style>